(function () {
  const applyAll = () => {
    document.querySelectorAll('variant-selects').forEach((host) => applyFilter(host));
  };

  const currentGroup = (host) => {
    const checked = host.querySelector('input[data-variant-group-filter]:checked');
    if (checked?.dataset.variantGroupFilter) return checked.dataset.variantGroupFilter;
    const selected = host.querySelector('select option[selected], select option:checked');
    return selected?.dataset.variantGroupFilter || '';
  };

  const knownGroups = (host) =>
    new Set(
      Array.from(host.querySelectorAll('[data-variant-group-filter]'))
        .map((el) => el.dataset.variantGroupFilter)
        .filter(Boolean)
    );

  const featuredMediaId = (host) => {
    const raw = host.querySelector('[data-selected-variant]')?.textContent;
    if (!raw) return '';
    try {
      const variant = JSON.parse(raw);
      return variant?.featured_media?.id ? String(variant.featured_media.id) : '';
    } catch (error) {
      return '';
    }
  };

  const applyFilter = (host) => {
    const productInfo = host.closest('product-info');
    const gallery =
      productInfo?.querySelector('media-gallery[data-variant-image-group="true"]') ||
      document.querySelector('media-gallery[data-variant-image-group="true"]');
    if (!gallery) return;

    const group = currentGroup(host);
    const known = knownGroups(host);
    const items = gallery.querySelectorAll('[data-variant-group]');
    let firstVisible = null;

    items.forEach((item) => {
      const itemGroup = item.dataset.variantGroup || '';
      const shared = !itemGroup || !known.has(itemGroup);
      const show = !group || shared || itemGroup === group;
      item.classList.toggle('variant-image-group-hidden', !show);
      if (show && !firstVisible) firstVisible = item;
    });

    const sectionId = gallery.id?.replace(/^MediaGallery-/, '') || host.dataset.section || '';
    const featuredId = featuredMediaId(host);
    const featured = featuredId
      ? gallery.querySelector(`[data-media-id="${sectionId}-${featuredId}"]:not(.variant-image-group-hidden)`)
      : null;
    const active = featured || firstVisible;
    if (active?.dataset.mediaId && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(active.dataset.mediaId, true);
    }

    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (viewer?.resetPages) viewer.resetPages();
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, applyAll);
    subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(applyAll));
  }

  document.addEventListener('change', (event) => {
    const host = event.target?.closest?.('variant-selects');
    if (host) applyFilter(host);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }
})();
